// sessions-archive.js — DONE sessions only. Frozen — grows only at session close.
// Imported by sessions.js thin aggregator. Never import directly in components.
// To add a session: move from sessions-active.js to here when status → done.
// Last updated: May 31, 2026 — Phase structure resequenced (0-12 + Monetise)
// Reviewed: May 27, 2026 — DOC-SYNC · archive is frozen · Railway references are historical records

export const ARCHIVE_SESSIONS = [

  // ─── FOUNDATION (DONE) ───────────────────────────────────────────────────
  {
      id: '1-14',
      sessionNumber: 'S1–S14',
      name: 'Core Platform — Auth, AI, Admin, Legal',
      status: 'done',
      phase: 'Phase 0 — Foundation',
      date: 'Feb 2026',
      commit: 'multiple',
      items: [
        'Auth: JWT 24hr, invite-only, email verify, password reset, auto-login after verify',
        'AI Analysis: BULLISH/NEUTRAL/BEARISH scoring engine (no Math.random)',
        'Modular backend: 1600-line monolith → routes/models/services/middleware',
        '18 legal compliance fixes (signal language, data delay, disclaimers)',
        '4-tab Admin Panel with 3-tier RBAC (User/Admin/SuperAdmin)',
        'Audit log, rate limiting, trust proxy (Railway), SMTP2GO email',
        'marketpulze.com domain live (GoDaddy → Cloudflare nameservers)',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '19',
      sessionNumber: 'S19',
      name: 'SEO Stock Pages',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Feb 2026',
      commit: 'multiple',
      items: [
        '229 /stocks/:ticker public pages (S&P 500)',
        'sitemap.xml generated (npm run sitemap)',
        'robots.txt — blocks /admin /profile /api/',
        'Rate-limited SEO endpoint: 30 req/15min',
        'public/_redirects for Cloudflare SPA routing',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '20-20B',
      sessionNumber: 'S20–S20B',
      name: 'Caching Layer',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Feb 2026',
      commit: 'multiple',
      items: [
        'node-cache 15-min TTL — quotes + chart/news/earnings/consensus (depthCache)',
        'MongoDB FundamentalsCache 24hr TTL — fixes weekend blank key metrics',
        '_source badge: live / cache / unavailable',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '21',
      sessionNumber: 'S21',
      name: 'Watchlist + Daily Digest',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Feb 2026',
      commit: 'multiple',
      items: [
        'MongoDB Watchlist (max 10 tickers per user)',
        'Daily digest cron: 7am UTC Mon-Fri (node-cron)',
        'GDPR/CAN-SPAM/CASL: explicit opt-in checkbox, consent timestamp, unsubscribe token',
        'One-click unsubscribe endpoint (no auth required)',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '22A',
      sessionNumber: 'S22A',
      name: 'Market Dashboard',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Mar 2026',
      commit: 'multiple',
      items: [
        '/market dedicated page',
        '4 index cards: S&P 500, DOW, NASDAQ, Russell 2000',
        'Market status badge: OPEN / PRE-MARKET / AFTER-HOURS / CLOSED (NYSE ET)',
        'Movers tabs: Gainers / Losers / Active',
        '11-sector heatmap via ETF proxies (XLF, XLE, XLK, XLI, XLY, XLP, XLV, XLU, XLB, XLRE, XLC)',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '22B',
      sessionNumber: 'S22B',
      name: 'Stock Page Depth',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Mar 2026',
      commit: '6815018',
      items: [
        'PriceChart.jsx — recharts AreaChart, 5 tabs 1D/1W/1M/3M/1Y',
        'NewsFeed.jsx — 5 Finnhub articles, ticker-filtered',
        'EarningsPanel.jsx — next earnings countdown + EPS bar chart',
        'AnalystConsensus.jsx — stacked bar + BULLISH/NEUTRAL/BEARISH badge',
        '4 depth endpoints in stocks-seo.js with 15-min depthCache',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '22C',
      sessionNumber: 'S22C',
      name: 'Historical Performance Calculator',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Mar 8, 2026',
      commit: 'eb3406b',
      items: [
        'CalculatorPage.jsx with ticker validation',
        'DRIP formula (mathematically correct dividend reinvestment)',
        '5 benchmarks: SPY / QQQ / GLD / BTC / CPI',
        'Dual recharts AreaChart (investment vs benchmark)',
        'Shareable URL: /calculator?ticker=AAPL&amount=1000&...',
        'MongoDB HistoricalCache 7-day TTL',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '22D',
      sessionNumber: 'S22D',
      name: 'Docs + Roadmap Page',
      status: 'done',
      phase: 'Phase 1 — Platform Core',
      date: 'Mar 9, 2026',
      commit: 'ca87149',
      items: [
        'HANDOVER.md Sections 16–32 added',
        'CLAUDE.md created for Claude Code CLI auto-context',
        '/roadmap Super Admin page (5 tabs)',
        'Extended competitive analysis — Finviz 10-page breakdown',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '23',
      sessionNumber: 'S23',
      name: 'Shareable Analysis Cards',
      status: 'done',
      phase: 'Phase 2 — Signal Collection',
      date: 'Mar 10, 2026',
      commit: '73db2d3',
      items: [
        'POST /api/share (optionalAuth) — MongoDB ShareCard 30-day TTL',
        'GET /api/share/:uuid — public, no auth',
        'ShareCard.jsx branded card — signal badge + score ring',
        '/share/:uuid SharePage — Download PNG, Copy Link, X/Twitter Share',
        'MANDATORY watermark: "Algorithmic signal · not investment advice"',
        '/trading/signals Super Admin signal journal',
        'T1: OG meta tags on SharePage (og:image, og:title, og:description)',
        'T2: Request Invite CTA on SharePage — acquisition path on every viral share',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '23B',
      sessionNumber: 'S23B',
      name: 'StockPage Full Scenario Overhaul',
      status: 'done',
      phase: 'Phase 2 — Signal Collection',
      date: 'Mar 10, 2026',
      commit: 'e7a0234→b6fa0ff',
      items: [
        'Chart: single AV call per ticker shared across all 5 tabs',
        'Tiingo 500/day free tier fallback (replaces AV quota exhaustion)',
        'Earnings: Alpha Vantage fallback when Finnhub returns empty',
        'News: ticker-mention filter',
        'Run Full Analysis inline above chart (AnalysisResult inline={true})',
        '429 → Upgrade CTA (orange), 403 → verify email (red), network → Try Again',
        'Auto-run analysis after sign-in from stock page gate (S3 scenario)',
        'fd field normalisation: pe→peRatio, high52w→week52High',
        'Re-run Analysis button + analyses remaining counter',
        'Section 20 StockPage scenario matrix (12 scenarios) documented',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '24-s25-s26',
      sessionNumber: 'S24–S26',
      name: 'Bug Fixes + Hero Components + Infrastructure',
      status: 'done',
      phase: 'Phase 2 — Signal Collection',
      date: 'Mar 2026',
      commit: '411ae55',
      items: [
        'S24: Key Metrics fixed (Revenue, Profit Margin, AvgVolume)',
        'S24: Duplicate stats grid hidden when member analysis loaded',
        'S24: hasStockPage self-maintaining — no static ticker list needed',
        'S24: SECTOR_MAP (11 sectors, 10 tickers each) for related stocks',
        'S25: Hero 3-panel (HeroPrice / HeroSignal / HeroCompany)',
        'S25: F1 Valuation Grade, F2 52-Week Position Bar',
        'S25: navigation.js contract — PAGES + AUTH_MODES (no raw strings in code)',
        'S25: Forgot password modal fix, NYSE ET market hours',
        'S25: Smoke test script: 29 checks locked into deploy sequence',
        'S26: Hero extraction into individual components',
        'S26: D2 SECTOR_MAP gaps filled, disclaimer split (guest vs member)',
        'S26: Rule 11 added (new feature sequence), Section 44 FMP prep',
        'S26: Ticker search bar on StockPage, clearAnalysis before redirect',
        'S26: Smoke test expanded to 36 checks',
      ],
      prereqs: [],
      doD: [],
      smokeChecks: [],
      files: [],
      vendorDeps: [],
    },

  {
      id: '24B',
      sessionNumber: 'S27A',
      name: 'Calendar View + News Feed + StockPage Tab Shell',
      status: 'done',
      date: 'March 2026',
      commit: '7e81f9e',
      phase: 'Phase 2 — Signal Collection',
      items: [
        '── /calendar NEW PAGE ──────────────────────────────────────────────────',
        'Tab 1 Earnings: Date | Ticker | AI Signal pill | EPS Est | EPS Actual | Surprise%',
        'Tab 2 Economic: Fed/CPI/NFP/GDP + Impact pill High/Medium/Low — NO AI signals (Legal L8)',
        'Tab 3 IPO: upcoming IPOs with price range — unique vs Finviz (they have no IPO tab)',
        'Week nav: ← Last / This / Next / +2 Weeks →',
        'Filter: All | My Watchlist (member) | Sector',
        'Guest CTA: "Track your watchlist earnings → Request Invite"',
        '── /news NEW PAGE ──────────────────────────────────────────────────────',
        'Single-column, 20 articles (Finviz/Scanz quality)',
        'Each item: Source | Relative time | Headline | Ticker tags | Sentiment pill',
        'Filter: All | Earnings | Economic | M&A | Macro | My Watchlist (locked for guests)',
        'Trending Tickers sidebar — most-mentioned tickers in last 20 articles',
        'Load more button (no infinite scroll — legal risk with auto-loading financial content)',
        '── PER-STOCK NEWS ENHANCEMENT (NewsFeed.jsx) ───────────────────────────',
        '5 → 20 articles with Load more button',
        'Add: sentiment pill, excerpt (~100 chars), relative time ("3h ago"), ★ Top Story marker',
        'Backend /news endpoint: expose sentiment + summary (Finnhub already returns these, were dropped)',
        '── STOCKPAGE TAB SHELL ─────────────────────────────────────────────────',
        'Tab navigation: Overview | Technicals | News | Insiders | Filings',
        'News tab: S27A content. Others: "Coming soon" placeholder for their own session.',
      ],
      prereqs: [
        'S26 ✅ confirmed — commit 411ae55, smoke-test 36/36 green',
        'Run bash scripts/smoke-test.sh — confirm 36/36 before starting',
        'Backend diagnostics: chart candles > 10, earnings records > 0, news articles > 0',
        'git branch --show-current must output: dev',
      ],
      doD: [
        '/calendar live — all 3 tabs load data (Earnings, Economic, IPO)',
        '/news live — 20 articles with sentiment pills and filters',
        'StockPage news shows 20 articles (was 5), sentiment + excerpt visible',
        'StockPage tab shell: Overview | Technicals | News | Insiders | Filings',
        'bash scripts/smoke-test.sh all checks pass (new S27A checks added)',
        'npm run build — zero errors',
        'sessions.js: this entry status → "done", date + commit added',
        'sessions.js: 22A-enhance (S27B) status → "next"',
      ],
      smokeChecks: [
        '[ -f "src/pages/CalendarPage.jsx" ] && echo "✅ CalendarPage exists" || echo "❌ CalendarPage missing"',
        'grep -q "PAGES.CALENDAR" src/navigation.js && echo "✅ PAGES.CALENDAR" || echo "❌ CALENDAR missing in navigation"',
        'grep -q "calendar" src/App.jsx && echo "✅ /calendar route in App" || echo "❌ /calendar missing in App"',
        '[ -f "backend/routes/calendar.js" ] && echo "✅ calendar route file" || echo "❌ calendar route missing"',
        '[ -f "src/pages/NewsPage.jsx" ] && echo "✅ NewsPage exists" || echo "❌ NewsPage missing"',
        'grep -q "PAGES.NEWS" src/navigation.js && echo "✅ PAGES.NEWS" || echo "❌ NEWS missing in navigation"',
        'grep -qE "Overview.*Technicals|tab.*shell|tabShell" src/pages/StockPage.jsx && echo "✅ StockPage tab shell" || echo "❌ tab shell missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/App.jsx',
        'src/navigation.js',
        'backend/routes/stocks-seo.js',
      ],
      vendorDeps: [
        { name: 'Finnhub', plan: 'Free', endpoint: '/calendar/earnings, /calendar/economic, /calendar/ipo, /news', status: 'confirmed' },
      ],
    },

  {
      id: 'signal-log', sessionNumber: 'S27A-backend',
      name: 'SignalLog Collection — Silent Logging From Day One',
      status: 'done', phase: 'Phase 2 — Signal Collection',
      items: [
        'Add SignalLog MongoDB collection: ticker, signal, score, timestamp, price, userId',
        'Populate silently from /api/stocks/analyze — zero UI needed now',
        'CRITICAL: If logging starts at S26 there is zero historical data for accuracy. Start NOW.',
        'Add backend/models/SignalLog.js + wire into stocks.js analyze endpoint. ~30 mins.',
      ],
      prereqs: ['S27A code session started'],
      doD: ['SignalLog model exists', 'analyze writes SignalLog on every run', 'smoke check added'],
      smokeChecks: ['test -f backend/models/SignalLog.js && echo "SignalLog model exists"'],
      files: ['backend/routes/stocks.js'], vendorDeps: [],
    },

  {
      id: '22A-enhance',
      sessionNumber: 'S27B',
      name: 'Market Dashboard Phase 2 — Intelligence Layer',
      status: 'done',
      date: 'March 2026',
      commit: '1d0f053',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'MD1: Fear & Greed Meter — computed from VIX + S&P momentum + breadth (no new API)',
        'MD2: VIX card with label: Low / Normal / Elevated / Extreme',
        'MD3: Treasury Yields strip — 1Y/5Y/10Y/30Y + 10Y-2Y spread (SHY/IEI/IEF/TLT)',
        'MD4: Commodities strip — Oil/Gold/Silver/Copper (USO/GLD/SLV/CPER)',
        'MD4+: Macro signals — USD Index(UUP), Credit Spreads(HYG/LQD), Gold/Silver ratio, Copper/Gold ratio',
        'MD5: Upcoming Earnings This Week — top 5 S&P500 reporters (Finnhub free)',
        'MD6: Economic Events Today — Fed/CPI/jobs (Finnhub free)',
        '★ MD7: AI Market Brief — 3-sentence Claude summary (unique — no competitor has this)',
        'MD2b: VVIX proxy via UVXY ETF — D3 ABORT signal when elevated',
        'MD8: Market Breadth — gainers vs losers ratio + BULLISH/NEUTRAL/BEARISH signal',
        'Macro panel: USD Index(UUP), Credit Spreads(HYG/LQD), Gold/Silver ratio, Copper/Gold ratio',
        'ETF persistent cache (etfCache.js) — MongoDB fallback for all market states',
        'Bootstrap seed from Alpha Vantage on startup — covers weekends/holidays/restarts',
        'Market state labels: LIVE / PRE_MARKET / AFTER_HOURS / WEEKEND / HOLIDAY',
        'D3_SIGNAL_UNIVERSE documented — 5 tiers, bidirectional PROCEED_LONG/SHORT/HEDGE/ABORT',
        'Cancel trigger: Bloomberg Basic / Marketwatch subscriptions after MD1-MD6 live',
      ],
      prereqs: [
        'S27A (id: 24B) ✅ deployed to production',
        '/calendar and /news live and accessible on marketpulze.com',
        'StockPage tab shell confirmed visible on live site',
        'bash scripts/smoke-test.sh — all S27A checks passing',
      ],
      doD: [
        '/market shows Fear & Greed, VIX, Yields, Commodities, Upcoming Earnings, Economic Events',
        'MD7 AI Brief renders with "AI-generated · not investment advice" label',
        'bash scripts/smoke-test.sh — all checks pass including S27B additions',
        'sessions.js: S27B → "done", S27C (22C-enhance) → "next"',
      ],
      smokeChecks: [
        'curl -s "https://marketpulze-production.up.railway.app/api/market/intelligence" | python3 -c "import sys,json; d=json.load(sys.stdin); print(\'MD7:\', bool(d.get(\'aibrief\')))" && echo "✅ intelligence endpoint" || echo "❌ intelligence endpoint missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/pages/MarketPage.jsx',
        'src/components/MarketDashboard.jsx',
        'backend/routes/market.js',
      ],
      vendorDeps: [
        { name: 'Finnhub', plan: 'Free', endpoint: '/calendar/earnings, /calendar/economic, ETF proxies', status: 'confirmed' },
        { name: 'Anthropic Claude', plan: 'API (existing key)', endpoint: 'claude-3-5-sonnet for MD7', status: 'confirmed' },
      ],
    },

  {
      id: '22C-enhance',
      sessionNumber: 'S27C',
      name: 'Calculator Phase 2 — DCA + Year Breakdown + Scenarios',
      status: 'done',
      date: 'March 2026',
      commit: '6d58f1e',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'C1: Year-by-year breakdown table — shares, dividends, portfolio value per year',
        'C2: DCA mode — monthly/quarterly contribution toggle',
        'C3: Dividend treatment 3-way toggle: Reinvest / Hold cash / Ignore',
        'C4: Split annotations on chart — vertical markers (Finnhub /stock/split, free)',
        'C5: Inflation-adjusted toggle — real vs nominal (uses existing CPI benchmark)',
        'C6: Multi-ticker comparison — up to 3 tickers, same investment same period',
        'C7: Future projection mode — forward-looking compound growth',
        'C8: What-if peak scenario — max return if sold at 52W high each year',
        '★ C9: AI Return Explainer — Claude explains WHY stock performed this way (unique)',
        'Cancel trigger: stocksplithistory.com + standalone DRIP calculators after C1-C5',
      ],
      prereqs: [
        'S27B (id: 22A-enhance) ✅ deployed to production',
        'Market Dashboard intelligence layer visible on live /market page',
        'bash scripts/smoke-test.sh — all S27B checks passing',
      ],
      doD: [
        'Calculator shows year-by-year breakdown table (C1)',
        'DCA mode works and recalculates correctly (C2)',
        'Split markers appear on chart (C4)',
        'bash scripts/smoke-test.sh — all checks pass',
        'sessions.js: S27C → "done", S27D (id: 24) → "next"',
      ],
      smokeChecks: [
        'grep -qE "dca|DCA" src/pages/CalculatorPage.jsx && echo "DCA in Calculator" || echo "FAIL: DCA not found"',
        'grep -qE "yearBreakdown|year-breakdown|yearByYear" src/pages/CalculatorPage.jsx && echo "year breakdown present" || echo "FAIL: year breakdown missing"',
        'grep -q "Licensed data providers" src/pages/CalculatorPage.jsx && echo "Calculator: no vendor in footer" || echo "FAIL: vendor name in calculator footer"',
        'grep -q "Market Data (Real-time)" backend/routes/stocks.js && echo "stocks.js: dataSource genericized" || echo "FAIL: vendor name in dataSource"',
        'grep -q "America/New_York" backend/routes/calculator.js && echo "Calculator: ET market hours gate" || echo "FAIL: market hours gate missing"',
        'grep -q "US_HOLIDAYS" backend/routes/calculator.js && echo "Calculator: holiday gate present" || echo "FAIL: holiday gate missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/pages/CalculatorPage.jsx',
        'backend/routes/calculator.js',
      ],
      vendorDeps: [
        { name: 'Finnhub', plan: 'Free', endpoint: '/stock/split for C4', status: 'confirmed' },
        { name: 'Anthropic Claude', plan: 'API (existing key)', endpoint: 'C9 AI Explainer', status: 'confirmed' },
      ],
    },

  {
      id: 'dashboard-member-page',
      sessionNumber: 'S27C-dashboard',
      name: 'Member Dashboard — /dashboard Command Center',
      status: 'done',
      phase: 'Phase 2 — Signal Collection',
      date: 'March 2026',
      commit: 'c943bb9',
      items: [
        '/dashboard route — member-only, redirects guests to home with auth modal',
        'WatchlistPanel moved from home to /dashboard — home is now clean for guests',
        'WatchlistRow: 350ms hover → HoverCard with 14-day sparkline, signal, price, actions',
        'HoverCard fetches /api/seo/:ticker/chart (cached, zero extra API cost)',
        'Add-ticker input on dashboard — members add without leaving to stock page',
        'MoversPanel: tabbed Gainers/Losers/Active (was 3-column grid)',
        'IntelStrip: Fear & Greed + VIX pill strip in market clock bar',
        'D3StatusPanel: Super Admin only — OCI BLOCKED / IB Gateway / Phase / Emergency stop',
        'SignalPreviewPanel on home: 4 live signals (AAPL/NVDA/MSFT/TSLA), rest gated',
        'Dashboard CTA on hero for logged-in members: "My Dashboard →"',
        'L2 violation fixed: removed "refreshed every 2 minutes" from HeroSection',
        'Header: memberLinks array — Dashboard nav link for logged-in users only',
        '★ D3 value: Dashboard is the Phase D command center. D3StatusPanel is the placeholder.',
        '★ D3 value: SignalPreviewPanel shows same Tier 1 signals D3 uses for pre-market scan.',
        '★ D3 value: Watchlist on dashboard = member crowd signal pipeline (member-data-d3).',
      ],
      prereqs: ['S27B complete', 'C0 calculator cache live'],
      doD: [
        '/dashboard loads for members, redirects guests',
        'Hover preview shows sparkline and signal',
        'Add ticker works on dashboard',
        'D3StatusPanel visible to Super Admin only',
        'Home page has no WatchlistPanel',
        'smoke-test.sh 110/110',
      ],
      smokeChecks: [
        'test -f src/pages/DashboardPage.jsx && echo "DashboardPage exists"',
        "grep -q 'dashboard' src/App.jsx && echo 'Dashboard route in App'",
        "grep -q 'HoverCard' src/pages/DashboardPage.jsx && echo 'HoverCard present'",
        "grep -q 'D3StatusPanel' src/pages/DashboardPage.jsx && echo 'D3StatusPanel present'",
        "test $(grep -c 'WatchlistPanel' src/App.jsx) -eq 0 && echo 'WatchlistPanel removed from home'",
      ],
      files: ['src/pages/DashboardPage.jsx', 'src/components/HeroSection.jsx', 'src/App.jsx', 'src/components/Header.jsx'],
      vendorDeps: [{ name: 'SEO chart endpoint', plan: 'existing cache', endpoint: '/api/seo/:ticker/chart', status: 'active' }],
    },

  {
      id: 'dsquare-site',
      sessionNumber: 'S27C-infra',
      name: 'Dsquare Corporate Site — dsquaresgroup.com',
      status: 'done',
      phase: 'Phase 2 — Signal Collection',
      date: 'March 2026',
      commit: 'n/a — separate repo dsquaresgroup/dsquaresgroup-site',
      items: [
        'Corporate site live at dsquaresgroup.com — Cloudflare Pages',
        'GitHub org: github.com/dsquaresgroup — separate from Marketpulze account',
        'Repo: dsquaresgroup/dsquaresgroup-site — private, single index.html',
        'DNS: dsquaresgroup.com moved from GoDaddy NS to Cloudflare (shubhi + vicente NS)',
        'DSQUARE LLC legal name confirmed from IRS S-Corp election letter (May 7 2025)',
        'Public brand: Dsquare (no suffix in nav). Legal: DSQUARE LLC in footer only.',
        'Logo: mirrored D mark — D + mirror(D) = D² — founder + daughter personal meaning',
        'Two D shapes facing each other (lens form) — gold gradient + ghost — trademark-ready geometric',
        'Constellation mark also designed: central hub + 4 satellite nodes (one lit = MarketPulze)',
        'Portfolio: MarketPulze (In Development · Early Beta) + Dsquare Trade (Planned) + Dsquare Enterprise (Planned)',
        'Contact: info@dsquaresgroup.com (group) + info@marketpulze.com (product)',
        'Trademark: MarketPulze™ and Dsquare™ as common law claims (™ not ® — no USPTO registration yet)',
        '™ correct without registration — ® requires USPTO filing',
        'Microsoft 365 Email Essentials: ~$2/mo GoDaddy exclusive bundle (corrected from Business Basic ~$6/mo)',
        'No personal name anywhere on site — no conflict with fulltime employment',
        'No location shown — standard for holding companies (Berkshire, Alphabet do not show address)',
        'Oracle expertise strip: group capability not consulting ad — no individual attribution',
        'GitHub org future team plan: separate teams per product, overlap members possible',
        'marketpulze repo transfer to dsquaresgroup org: AFTER Oracle call confirmed (no disruption risk)',
      ],
      prereqs: [],
      doD: [
        'dsquaresgroup.com loads correctly',
        'DNS on Cloudflare nameservers',
        'Cloudflare Pages custom domain connected',
        'All three portfolio cards show correct status',
        'No personal name or address visible',
        'Contact emails correct: info@dsquaresgroup.com + info@marketpulze.com',
      ],
      smokeChecks: [],
      files: ['dsquaresgroup-site/index.html'],
      vendorDeps: [],
    },

  {
      id: '24',
      sessionNumber: 'S27D',
      name: 'Stock Screener — Guest Version',
      status: 'done',
      date: 'March 2026',
      commit: 'c1c21ea',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'Guest: signal filter (BULLISH/NEUTRAL/BEARISH) + sector filter',
        'Guest: sort by score / price change / market cap',
        'Pre-built scans: Top BULLISH Signals, Volume Breakouts, Oversold Bounce',
        'Pre-built: Earnings This Week, 52W High Breakout, Value Dip, Momentum Surge',
        'Results: sortable table — signal badges + score rings + ticker links',
        'Data: reuse existing SEO cache (node-cache 15-min) — NO new API calls',
        'Guest CSV export attempt → gate: "Members get CSV export → Request Invite"',
        'Member filters (P/E, market cap, score range): ADD ONLY AFTER FMP confirmed',
        'Legal: "Screener results are algorithmic signals — not investment advice"',
      ],
      prereqs: [
        'S27C (id: 22C-enhance) ✅ deployed to production',
        'Congressional data vendor decision made (see congressional-data-decision session)',
        'Member filters (P/E, market cap): only after vendor confirmed and licensed',
        'bash scripts/smoke-test.sh — all S27C checks passing',
      ],
      doD: [
        '/screener live — guest can filter by signal + sector, sortable results',
        'At least 3 pre-built scan buttons working',
        'Guest CSV attempt shows gate (no actual export for guests)',
        'Member filters: only if FMP confirmed, else "Coming soon · Phase C" placeholder',
        'bash scripts/smoke-test.sh — all checks pass',
        'sessions.js: S27D → "done", Phase C sessions remain status: "planned"',
      ],
      smokeChecks: [
        '[ -f "src/pages/ScreenerPage.jsx" ] && echo "✅ ScreenerPage" || echo "❌ ScreenerPage missing"',
        '[ -f "backend/routes/screener.js" ] && echo "✅ screener route" || echo "❌ screener route missing"',
        'grep -q "screener" src/App.jsx && echo "✅ /screener in App" || echo "❌ /screener missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/App.jsx',
      ],
      vendorDeps: [
        { name: 'Finnhub', plan: 'Free', endpoint: 'reuse existing SEO cache — no new calls', status: 'confirmed' },
        { name: 'FMP', plan: 'Basic $19/mo', endpoint: 'member filters ONLY — wait for licensing', status: 'pending — monday meeting' },
      ],
    },

  {
      id: 'S26E',
      sessionNumber: 'S27E',
      name: 'Chart Upgrade — Candlestick + Volume Bars',
      status: 'done',
      date: 'March 2026',
      commit: '216ca72',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'Replace recharts AreaChart with TradingView Lightweight Charts library (MIT, ~40KB, free)',
        'IMPORTANT: TradingView Lightweight Charts = open-source library (github.com/tradingview/lightweight-charts)',
        'This is NOT the TradingView.com subscription ($15/mo) — that is a competitor we are replacing',
        'We own the chart output completely: dark theme, zero branding, zero attribution required',
        'Candlestick chart with OHLCV from existing Marketstack cache',
        'Volume bars histogram in sub-panel below price',
        'Multi-timeframe: 1D / 1W / 1M / 3M / 1Y / 5Y',
        'Crosshair with OHLCV tooltip: Open $X · High $X · Low $X · Close $X · Vol X',
        'AI signal overlay: small BULLISH/BEARISH markers on chart where signal changed',
        'Responsive — chart resizes on mobile and desktop',
        'Guest: full candlestick chart visible',
        'Member: same chart + signal overlay markers',
        '★ Personal /trading suite: chart accessible from watchlist + scanner results',
        'StockCharts.com replacement: basic charting covered after this session',
        'TradingView subscription cancel trigger: after this session (basic chart live)',
      ],
      prereqs: [
        'S27D (id: 24) ✅ deployed to production — screener live',
        'bash scripts/smoke-test.sh all checks passing',
      ],
      doD: [
        'PriceChart.jsx uses TradingView Lightweight Charts library (not recharts)',
        'Candlestick renders correctly on /stocks/:ticker for all 6 timeframes',
        'Volume histogram visible below price panel',
        'OHLCV crosshair tooltip working',
        'No blank chart on any timeframe (data loads from Marketstack cache)',
        'Mobile responsive — chart fills container, no overflow',
        'npm run build clean — no ESLint errors',
        'bash scripts/smoke-test.sh — new chart smoke checks added and passing',
        'sessions.js: S26E → done, S27B → next (S27B adds RSI/MACD)',
      ],
      smokeChecks: [
        'grep -qE "lightweight-charts|createChart|IChartApi" src/components/PriceChart.jsx && echo "✅ Lightweight Charts" || echo "❌ Lightweight Charts missing"',
        'grep -qE "CandlestickSeries|addCandlestickSeries" src/components/PriceChart.jsx && echo "✅ Candlestick series" || echo "❌ Candlestick missing"',
        'grep -qE "HistogramSeries|addHistogramSeries" src/components/PriceChart.jsx && echo "✅ Volume histogram" || echo "❌ Volume histogram missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/components/PriceChart.jsx',
        'src/pages/StockPage.jsx',
        'src/data/sessions.js',
      ],
      vendorDeps: [
        { name: 'TradingView Lightweight Charts', plan: 'MIT open source — free forever', endpoint: 'npm install lightweight-charts', status: 'zero cost, zero attribution required' },
        { name: 'Marketstack Business', plan: '$127.99/mo ($1,535.88/yr) PLANNED', endpoint: '/api/seo/:ticker/chart', status: 'Phase B evaluation' },
      ],
    },

  {
      id: 'S27F',
      sessionNumber: 'S27F',
      name: 'Chart Indicators — SMA Overlays + RSI Sub-panel',
      status: 'done',
      date: '2026-03',
      commit: 'aa2e0ad',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'SMA 20 / SMA 50 / SMA 200 as LineSeries overlays on candlestick chart',
        'Toggle buttons per SMA line — user can show/hide each independently',
        'SMA calculated from candle data client-side — no new vendor, no new endpoint',
        'RSI(14) sub-panel below volume — separate pane, 0-100 scale',
        'RSI overbought line at 70 (red dashed) + oversold line at 30 (green dashed)',
        'SMA crossover logged to ChartInteractionLog as D3 signal event',
        'Guest: full indicators visible — no lock on chart',
        'Member: same + crossover markers persist across sessions (MongoDB)',
        'StockCharts $20.75/mo cancel trigger: after this session (SMA+RSI = 80% parity)',
      ],
      prereqs: [
        'S27E (id: S26E) ✅ deployed — lightweight-charts + ChartInteractionLog live',
        'bash scripts/smoke-test.sh 131/131 passing',
      ],
      doD: [
        'SMA 20/50/200 rendered as LineSeries on PriceChart.jsx',
        'Toggle buttons show/hide each SMA independently',
        'RSI(14) sub-panel renders below volume histogram',
        'Overbought (70) and oversold (30) horizontal lines on RSI panel',
        'No blank chart — SMA falls back gracefully if fewer candles than period',
        'Mobile responsive — indicators visible without overflow',
        'npm run build clean',
        'bash scripts/smoke-test.sh — new indicator smoke checks added and passing',
        'sessions.js: S27F → done, S27G → next',
      ],
      smokeChecks: [
        'grep -qE "LineSeries|addLineSeries" src/components/PriceChart.jsx && echo "✅ SMA LineSeries" || echo "❌ SMA missing"',
        'grep -qE "SMA|sma|movingAverage" src/components/PriceChart.jsx && echo "✅ SMA calculation" || echo "❌ SMA calc missing"',
        'grep -qE "RSI|rsi" src/components/PriceChart.jsx && echo "✅ RSI panel" || echo "❌ RSI missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/components/PriceChart.jsx',
        'src/data/sessions.js',
      ],
      vendorDeps: [
        { name: 'lightweight-charts', plan: 'MIT — already installed', status: 'confirmed' },
      ],
    },

  {
      id: 'S27G',
      sessionNumber: 'S27G',
      name: 'Chart Drawings — Trendlines + Horizontal Levels + DrawingLog',
      status: 'done',
      date: '2026-03-31',
      commit: 'a36c6f0',
      phase: 'Phase 2 — Signal Collection',
      items: [
        'Trendline drawing tool on PriceChart — click+drag to create trend lines',
        'Horizontal price level tool — single click to pin a level',
        'DrawingLog: new MongoDB model — member-drawn levels logged as D3 Tier 3',
        'D3 value: crowd-validated support/resistance — multiple members drawing same level = stronger signal',
        'No vendor sells per-member drawn price levels. This is the moat.',
        'Guest: drawing tool visible and usable — guest drawings logged to DrawingLog with isGuest:true',
        'Member: drawings persist across sessions (MongoDB keyed by memberId+ticker+price)',
      ],
      prereqs: [
        'S27F ✅ deployed — SMA 20/50/200 + RSI(14) live',
        'bash scripts/smoke-test.sh 134/134 passing',
      ],
      doD: [
        'Trendline tool: click+drag creates line on candlestick chart',
        'Horizontal level: single click places persistent price level line',
        'DrawingLog model: backend/models/DrawingLog.js with ticker, price, drawingType, memberId, isGuest, sessionHour, marketStatus',
        'Drawing events fire-and-forget logged to /api/chart-signals/log (extend eventType) or dedicated route',
        'No chart regression — candlestick + SMA + RSI all still render correctly',
        'npm run build clean — zero ESLint errors',
        'bash scripts/smoke-test.sh — new drawing smoke checks added and passing',
        'sessions.js: S27G → done, S27H or next chart session → next',
      ],
      smokeChecks: [
        'test -f backend/models/DrawingLog.js && echo "✅ DrawingLog model" || echo "❌ DrawingLog missing"',
        'grep -qE "DrawingLog|drawingLog" src/components/PriceChart.jsx && echo "✅ DrawingLog in PriceChart" || echo "❌ DrawingLog missing"',
        'grep -qE "trendline|horizontal|drawing" src/components/PriceChart.jsx && echo "✅ Drawing tools present" || echo "❌ Drawing tools missing"',
      ],
      files: [
        'HANDOVER.md',
        'src/components/PriceChart.jsx',
        'backend/models/DrawingLog.js',
        'backend/server.js',
        'src/data/sessions.js',
      ],
      vendorDeps: [
        { name: 'lightweight-charts', plan: 'MIT — already installed — v4 ISeriesApi.attachPrimitive() for custom drawing', status: 'confirmed' },
      ],
    },

  {
      id: 'guest-rate-limiting', sessionNumber: '02cd4d7',
      name: 'Guest Rate Limiting — API Quota Protection',
      status: 'done', date: '2026-04-01', commit: '02cd4d7', phase: 'Phase 2 — Signal Collection',
      items: [
        'Screener = highest-traffic page — unprotected guests burn AV 500/day quota',
        'One scraper can exhaust daily API quota in minutes',
        'Auth endpoints rate-limited — SEO endpoints are not',
        'Add per-IP: 100 screener requests/hr, 200 stock page requests/hr',
        'Use express-rate-limit (already in package.json) — extend to SEO routes',
        'Return 429 with Retry-After header — friendly not silent drop',
      ],
      prereqs: ['S27D screener complete'],
      doD: ['Rate limiting on /api/seo/* and screener', 'Tested with curl loop'],
      smokeChecks: ['grep -q "rateLimiter" backend/routes/stocks-seo.js && echo "SEO rate limiter present"'],
      files: ['backend/routes/stocks-seo.js'], vendorDeps: [],
    },

  {
    id: 'config-management',
    sessionNumber: '3f6d7a9',
    name: 'Config Management — Operational Config to MongoDB Settings + Admin Panel Tab',
    status: 'done',
    date: '2026-04-01',
    phase: 'Phase 2 — Signal Collection',
    items: [
      'PROBLEM: rate limits hardcoded in code, feature flags nowhere, Railway vars disappear on OCI migration',
      'getConfig(key, defaultValue) helper — backend reads Settings collection with 1hr in-memory cache',
      'Settings collection already exists (key/value store) — extend, do not replace',
      'Rate limit keys: guest_screener_limit_per_hour, guest_stockpage_limit_per_hour, guest_rate_limit_enabled',
      'Feature flag keys: maintenance_mode, registration_open, digest_enabled, screener_guest_limit',
      'Config values: analysis_limit_per_month, max_watchlist_size, invite_batch_size',
      'Admin panel: new "Configuration" tab — shows all Settings keys with editable values',
      'Config tab: grouped by category (Rate Limits / Feature Flags / Operational / Legal)',
      'Config tab: change value inline → POST /api/admin/settings → clears cache → takes effect immediately',
      'No deploy required to change any operational setting — this is the goal',
      'SECURITY BOUNDARY: SUPER_ADMIN_EMAILS stays in env var forever — never in DB',
      'SECURITY BOUNDARY: API keys (AV, Finnhub, JWT_SECRET) stay in env var forever',
      'OCI Vault integration note: document which env vars move to Vault in OCI-2 session',
      'Guest rate limiting uses getConfig() — same limits work on Railway, OCI, Hetzner',
      'D3 value: feature flags control signal collection features without deploys',
    ],
    prereqs: [
      'guest-rate-limiting deployed — first consumer of getConfig()',
    ],
    doD: [
      'getConfig(key, default) helper in backend/utils/config.js — reads Settings, 1hr cache, fallback to default',
      'guest-rate-limiting routes use getConfig() not hardcoded values',
      'Admin panel: Configuration tab visible (admin role, not super-admin only)',
      'Configuration tab shows all Settings keys grouped by category',
      'Changing a value via UI takes effect within 60 seconds (cache TTL)',
      'SUPER_ADMIN_EMAILS and API keys NOT shown or editable in Config tab',
      'CI=true npm run build clean',
      'smoke-test.sh — config helper + admin config tab checks passing',
    ],
    smokeChecks: [
      'test -f backend/utils/config.js && echo "getConfig helper exists"',
      'grep -q "getConfig" backend/routes/stocks-seo.js && echo "getConfig used in SEO route"',
      'grep -q "Configuration" src/pages/AdminPage.jsx && echo "Configuration tab in Admin"',
    ],
    files: [
      'backend/utils/config.js',
      'backend/routes/admin.js',
      'backend/routes/stocks-seo.js',
      'src/pages/AdminPage.jsx',
      'src/data/sessions.js',
    ],
    vendorDeps: [],
  },

  {
    id: 'auth-refresh-tokens',
    sessionNumber: 'auth-refresh-tokens',
    name: 'Auth Refresh Tokens — Seamless Sessions + D3 Device Identity',
    status: 'done',
    date: '2026-04-02',
    commit: 'cc61eb5',
    phase: 'Phase 2 — Signal Collection',
    items: [
      'Current: 24hr JWT-only — member session expires silently, UX degraded',
      'Option C (full refresh token pattern): httpOnly cookie + DB-stored hashed refresh tokens',
      'RefreshToken model: token (SHA-256 hashed), userId, expiresAt (30d), deviceId, createdAt',
      'POST /api/auth/refresh: validate refresh token cookie → issue new 24hr access token → rotate refresh token',
      'Token rotation: old refresh token invalidated on every refresh — stolen token detection',
      'Login response: sets httpOnly cookie (refresh token) + returns access token in body',
      'Logout: deletes refresh token from DB + clears cookie — true server-side logout',
      'useAuth.js frontend interceptor: catches 401 → calls /refresh → retries original request silently',
      'Member experience: seamless 30-day sessions — no mid-session auth interruption ever',
      'Guest: no change — guests have no tokens to refresh',
      'isAuthenticatedRequest in config.js: unchanged — verifies access token only',
      'D3 engine device identity: deviceId field on refresh token — engine identified separately from browsers',
      'D3 value: engine token = persistent identity for 24/7 operation, never expires while refreshing',
      'Middleware sliding window: if access token expires within 2hr → attach fresh token in X-Refresh-Token header',
      'SECURITY: SHA-256 hash before DB storage — raw tokens never stored anywhere',
      'SECURITY: httpOnly + Secure + SameSite=Strict cookie — not accessible to JS',
    ],
    prereqs: [
      'config-management deployed — Admin Settings UI live',
    ],
    doD: [
      'POST /api/auth/login sets httpOnly refresh token cookie + returns access token',
      'POST /api/auth/refresh validates cookie → issues new access token → rotates refresh token',
      'POST /api/auth/logout deletes DB record + clears cookie',
      'useAuth.js: 401 interceptor calls /refresh, retries, logs out only on refresh failure',
      'Member leaving tab open 7+ days: session still active on return (refresh token valid)',
      'Stolen refresh token scenario: rotation means old token invalid after first use',
      'D3 engine deviceId: distinct from browser sessions in all DB queries',
      'RefreshToken model indexed on userId + expiresAt for cleanup queries',
      'CI=true npm run build clean — zero ESLint errors',
      'smoke-test.sh: auth refresh endpoint + RefreshToken model checks passing',
    ],
    smokeChecks: [
      'test -f backend/models/RefreshToken.js && echo "RefreshToken model exists"',
      'grep -q "refresh" backend/routes/auth.js && echo "refresh endpoint in auth.js"',
      'grep -q "httpOnly" backend/routes/auth.js && echo "httpOnly cookie set on login"',
      'grep -qE "X-Refresh-Token|refresh" src/hooks/useAuth.js && echo "interceptor in useAuth"',
    ],
    files: [
      'backend/models/RefreshToken.js',
      'backend/routes/auth.js',
      'src/hooks/useAuth.js',
      'src/data/sessions.js',
    ],
    vendorDeps: [],
  },

  {
    id: 'S27H',
    sessionNumber: 'S27H',
    name: 'Advanced Chart Page + Indicators Phase 2 — Full-Page Chart + Bollinger + MACD + VWAP + EMA + Templates',
    status: 'done',
    date: 'April 2, 2026',
    commit: 'f0ecd84',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '/chart/:ticker route + ChartPage.jsx — full viewport, no StockPage layout constraints, calc(100vh - header)',
      'Expand icon on Technicals tab navigates to /chart/:ticker preserving current timeframe in URL',
      'PriceChart fullscreen prop — unlocks taller container, indicator sidebar, template picker',
      'Bollinger Bands (20, 2-sigma) — two LineSeries + shaded fill between them, client-side calcBollinger()',
      'MACD (12/26/9) — sub-panel below RSI: HistogramSeries (histogram) + LineSeries (signal line + MACD line)',
      'VWAP — single LineSeries on 1D tab only, calculated from cumulative (price*volume)/cumulative volume',
      'EMA with custom period input — calcEMA() function, exponential weighting, member types any period',
      'Stochastic oscillator (14,3,3) — sub-panel, %K and %D lines, overbought 80/oversold 20 reference lines',
      'Indicator templates: Day Trader (VWAP+EMA9+EMA21) · Swing Trader (SMA20+SMA50+RSI+MACD) · Breakout Hunter (BB+Volume+VWAP) · Oversold/Overbought (RSI+Stochastic+BB) · Trend Follower (SMA50+SMA200)',
      'URL state: /chart/NVDA?tf=1M&indicators=bb,macd,vwap&template=daytrader — shareable + bookmarkable',
      'IndicatorLayout model — MongoDB: memberId+ticker indexed, indicator state persisted, restored on return visit',
      'scanContext prop on PriceChart — passed from screener navigation, logged on all chart events',
      'template_load event logged to ChartInteractionLog with template name + indicator combination',
      'custom_ema_period event logged — specific period used = unique strategy fingerprint per member',
      'Guest: indicator state in URL only, no persistence, D3 logged with isGuest: true',
      'Member: last indicator set saved to MongoDB IndicatorLayout, restored on next /chart/:ticker visit',
      'Library decision: STAY on lightweight-charts. No migration. KLineChart/D3.js adds no D3 signal value.',
    ],
    prereqs: [
      'S27G deployed — trendlines + horizontal levels + DrawingLog live',
      'guest-rate-limiting deployed',
    ],
    doD: [
      '/chart/:ticker renders full viewport height — no StockPage layout constraints',
      'Expand icon on /stocks/:ticker Technicals tab navigates to /chart/:ticker',
      'Bollinger Bands render as two LineSeries with shaded fill on main chart',
      'MACD renders as histogram + two signal lines in 3rd sub-pane below RSI',
      'VWAP renders on 1D timeframe only, hidden on all others',
      'EMA period input accepts custom value — calcEMA runs with that period, logged to D3',
      '5 templates visible in indicator sidebar — each loads correct indicator set on click',
      'template_load event in ChartInteractionLog — D3 strategy declaration signal',
      'URL state preserved — /chart/NVDA?tf=1M&indicators=bb,macd loads same setup',
      'Member indicator layout persists (MongoDB IndicatorLayout) — restored on next visit',
      'scanContext from screener navigation logged on all chart events',
      'No regression: candlestick + SMA + RSI + trendlines + horizontal levels all render',
      'CI=true npm run build clean — zero ESLint errors',
      'bash scripts/smoke-test.sh — new chart page + indicator smoke checks passing',
    ],
    smokeChecks: [
      'test -f src/pages/ChartPage.jsx && echo "ChartPage.jsx exists"',
      'grep -q "/chart" src/App.jsx && echo "/chart route in App.jsx"',
      'test -f backend/models/IndicatorLayout.js && echo "IndicatorLayout model exists"',
      'grep -qE "calcBollinger|bollinger|Bollinger" src/components/PriceChart.jsx && echo "Bollinger in PriceChart"',
      'grep -qE "calcMACD|macd|MACD" src/components/PriceChart.jsx && echo "MACD in PriceChart"',
      'grep -qE "calcVWAP|vwap|VWAP" src/components/PriceChart.jsx && echo "VWAP in PriceChart"',
      'grep -qE "template|Template|daytrader|swing" src/components/PriceChart.jsx && echo "Templates in PriceChart"',
    ],
    files: [
      'src/pages/ChartPage.jsx',
      'src/components/PriceChart.jsx',
      'backend/models/IndicatorLayout.js',
      'backend/routes/indicator-layouts.js',
      'backend/server.js',
      'src/App.jsx',
      'src/data/sessions.js',
    ],
    vendorDeps: [
      { name: 'lightweight-charts', plan: 'MIT — already installed — extend with new calcXXX functions only', status: 'confirmed' },
      { name: 'technicalindicators (optional)', plan: 'MIT — npm install if formula complexity warrants', status: 'evaluate at session start' },
    ],
  },

  {
    id: 'S27H-hotfix1',
    sessionNumber: 'S27H-hotfix1',
    name: 'TV Logo Removal — Remove Lightweight-Charts Attribution Mark',
    status: 'done',
    phase: 'Phase 2 — Signal Collection',
    date: 'April 7, 2026',
    commit: 'pending',
    items: [
      'Single CSS rule in src/index.css — hides .tv-lightweight-charts attribution mark',
      'Applies across all 4 chart instances: main chart + RSI + MACD + Stochastic panels',
      'Apache 2.0 license confirmed — no attribution required in UI, legally clean',
      'Zero JS changes, zero smoke additions, zero sync files required',
      'Our chart must have NO vendor identity — our brand only (unique design principle)',
      'SESSION_TYPE=hotfix — changed files only: src/index.css',
    ],
    prereqs: ['S27H deployed ✅'],
    doD: ['TV attribution mark invisible on all chart instances on live site'],
    smokeChecks: [
      'grep -q "tv-lightweight-charts" src/index.css && echo "TV logo hide rule present"',
    ],
    files: ['src/index.css'],
    vendorDeps: [],
  },

  {
    id: 'S27-ALGO',
    sessionNumber: 'S27-ALGO',
    name: 'Algorithm V2 — 5-Dimension Scoring + Genuine BEARISH + Target Price Range',
    status: 'done',
    date: 'April 7, 2026',
    commit: '5c27af5',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── WHY THIS IS THE HIGHEST PRIORITY SESSION ─────────────────────────────',
      'Current algorithm always outputs BULLISH/NEUTRAL — never genuine BEARISH',
      'Root cause: score = 50 + slight momentum + 52W position bias = always 55-65',
      'No dimension can push score below 40 (BEARISH threshold) under current math',
      'Impact: every D3 signal logged from S27D-S27H is anchored to faulty BULLISH scores',
      'D3 signal variance = zero → D3 contrarian conviction signals impossible',
      'Fix the engine first. Everything downstream (fibonacci, screener, alerts) depends on it.',
      '── 5-DIMENSION SCORING ARCHITECTURE ────────────────────────────────────',
      'Each dimension independently positive OR negative — any can produce genuine BEARISH',
      '',
      'D1: Momentum Quality (−20 to +20)',
      '  1D / 5D / 20D price change, volume-weighted',
      '  RSI: >70 = overbought penalty (−8), <30 = oversold opportunity (+8)',
      '  Price vs SMA20/SMA50/SMA200: each above = +pts, each below = −pts',
      '  Volume confirmation: up day on 2× avg volume = bonus. Up day on <0.5× = penalty.',
      '',
      'D2: Trend Structure (−20 to +20)',
      '  SMA20 > SMA50 > SMA200 golden stack = +20 (max)',
      '  Death cross active (SMA20 < SMA50) = −15',
      '  52W position: U-curve scoring — 40-70% range = sweet spot (+pts)',
      '    <10% of range = near 52W low (potential value OR deteriorating)',
      '    >92% of range = near 52W high (mean reversion risk)',
      '    Both extremes treated as caution zones, not automatic bullish',
      '',
      'D3: Relative Strength vs Market (−15 to +15)',
      '  Stock return vs SPY over 20D and 60D — outperform = +, underperform = −',
      '  Source: existing SEO chart data + SPY from MarketDashboard ETF cache',
      '  Single biggest improvement — transforms "is this stock up?" → "does it beat market?"',
      '',
      'D4: Fundamentals (0 to +15, always 0 if data unavailable — never penalises)',
      '  P/E vs sector median if available from Finnhub /stock/metric',
      '  ETFs and unknown tickers: skip cleanly, no penalty for missing data',
      '  Revenue growth trend if available',
      '',
      'D5: Risk Factors (−25 to 0, always negative or zero)',
      '  30D realised volatility > 50% annualised = −10',
      '  VIX > 25 (market regime from MarketDashboard) = −8 on all tickers',
      '  Earnings within 5 calendar days = −7 (uncertainty premium)',
      '',
      'FINAL: 50 + D1 + D2 + D3 + D4 + D5',
      'BANDS: 0-39 = BEARISH · 40-59 = NEUTRAL · 60-79 = BULLISH · 80-100 = STRONG',
      '',
      '── TARGET PRICE FIX ─────────────────────────────────────────────────────',
      'Current: close × (1 + score/5000) — always 1-3% above current. Useless.',
      'New: weighted blend with honest confidence band',
      '  SMA200 30-day projection     25% weight',
      '  52W high (if in uptrend)     25% weight',
      '  Analyst consensus (Finnhub)  30% weight (0 weight if unavailable)',
      '  Simple DCF if P/E available  20% weight (0 weight if unavailable)',
      '  Reweight automatically if components unavailable',
      'Output: "$10.80 — $12.20" range + confidence label, NOT a pinpoint',
      'Label: "Model Range (Algorithmic)" — honest about uncertainty',
      'HeroSignal.jsx: display range instead of single target price',
      '',
      '── SCORING BREAKDOWN UI ─────────────────────────────────────────────────',
      'Extend existing scoring breakdown to show all 5 dimensions with values',
      'Members see exactly what drove their score — builds trust and transparency',
      'D3 value: member disagreeing with specific dimension = targeted contrarian signal',
      '',
      '── D3 VALUE ─────────────────────────────────────────────────────────────',
      'When algorithm correctly scores BEARISH and member buys anyway = contrarian conviction',
      'Signal variance IS the D3 value. Broken algorithm = zero variance = zero D3 value.',
      'Relative strength (D3 dimension) feeds D3 T4 momentum gate directly',
      'Risk factors (D5 dimension) aligns with D3 T1 regime gate (VIX input)',
    ],
    prereqs: ['S27H deployed ✅', 'S27H-hotfix1 deployed ✅'],
    doD: [
      'Algorithm produces genuine BEARISH scores (test: stock in clear downtrend must score < 40)',
      'Relative strength vs SPY calculated from existing ETF cache (no new vendor needed)',
      'RSI penalty active: ticker with RSI > 70 must score lower than same ticker at RSI 50',
      'Death cross penalty active: SMA20 < SMA50 must subtract ≥ 12 pts',
      'VIX > 25 from MarketDashboard reduces all scores by −8 (no additional API call)',
      'Target price shows as range "$X.XX — $X.XX" not single value',
      'HeroSignal.jsx: "Model Range (Algorithmic)" label on target price display',
      'Scoring breakdown in StockPage shows all 5 dimensions with labels and values',
      'SignalLog still records correctly on every analysis run (no regression)',
      'CI=true npm run build clean — zero ESLint errors',
      'smoke-test.sh: algorithm V2 checks passing',
    ],
    smokeChecks: [
      'grep -qE "relativeStrength|spyReturn|d3_relative" backend/routes/stocks.js && echo "Relative strength in algorithm"',
      'grep -qE "riskPenalty|vixPenalty|D5" backend/routes/stocks.js && echo "Risk dimension in algorithm"',
      'grep -qE "deathCross|goldenStack|smaStack" backend/routes/stocks.js && echo "Trend structure in algorithm"',
      'grep -qE "Model Range|modelRange|targetLow|targetHigh" src/components/stock/HeroSignal.jsx && echo "Target range in HeroSignal"',
    ],
    files: [
      'backend/routes/stocks.js',
      'backend/routes/stocks-seo.js',
      'src/components/stock/HeroSignal.jsx',
      'src/data/sessions.js',
    ],
    vendorDeps: [
      { name: 'Finnhub', plan: 'Free', endpoint: '/stock/metric (P/E, revenue growth)', status: 'Already in stack' },
      { name: 'MarketDashboard ETF cache', plan: 'Internal', endpoint: 'VIX + SPY from existing cache', status: 'Already live — zero new cost' },
    ],
  },

  {
    id: 'S27-ALGO-V3',
    sessionNumber: 'S27-ALGO-V3',
    name: 'Algorithm V3 — Two-Layer Fundamental Quality Gate + Analyst Target Price',
    status: 'done',
    date: 'April 2026',
    commit: 'see-hotfix4',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── WHY V2 IS STILL INSUFFICIENT ────────────────────────────────────────',
      'V2 fixes always-BULLISH (signal variance) but scores from price data alone',
      'ORCL junk bond status: invisible to V2 → NEUTRAL for wrong reasons',
      'RL overvaluation vs analyst consensus: invisible to V2 → false BULLISH',
      'Institutional analysis requires: fundamentals gate + momentum timing',
      'V2 is correct interim fix for D3 signal variance — V3 is the real engine',
      'Vision: "Institutional analysis in under 30 seconds" — this session delivers it',
      '',
      '── DATA ALREADY IN PIPELINE — ZERO NEW VENDORS ─────────────────────────',
      'AV OVERVIEW (already fetched, MongoDB-cached) — currently unused in scoring:',
      '  QuarterlyRevenueGrowthYOY · ProfitMarginTTM · ReturnOnEquityTTM',
      '  AnalystTargetPrice ← KEY for target price (already fetched, never used)',
      '  ForwardPE · 50DayMovingAverage · 200DayMovingAverage (real SMAs)',
      'Finnhub /stock/metric (already fetched in fallback path) — currently unused:',
      '  debtEquityQuarterly ← catches ORCL junk territory',
      '  grossMarginTTM · roeTTM · revenueGrowthTTMYoy · netMarginTTM',
      'Fix: fetch Finnhub metrics in PARALLEL with AV in member path (not just fallback)',
      'Pass ALL fundamental data into generateAnalysis() — currently only beta+avgVol',
      '',
      '── LAYER 1: FUNDAMENTAL QUALITY SCORE (FQ, 0–100) ──────────────────────',
      'Dim A — Revenue Health (0–25): QuarterlyRevenueGrowthYOY',
      '  >15%=25 · 5-15%=18 · 0-5%=10 · -5-0%=3 · <-5%=0 · N/A=12',
      'Dim B — Profitability (0–25): ProfitMarginTTM or netMarginTTM',
      '  >20%=25 · 10-20%=18 · 5-10%=12 · 0-5%=5 · <0%=0 · N/A=12',
      'Dim C — Debt Health (0–25): debtEquityQuarterly ← CATCHES ORCL',
      '  <0.3=25 · 0.3-0.8=20 · 0.8-1.5=12 · 1.5-3.0=5 · >3.0=0 · N/A/ETF=15',
      'Dim D — Return Quality (0–25): ReturnOnEquityTTM or roeTTM',
      '  >20%=25 · 12-20%=18 · 5-12%=10 · 0-5%=4 · <0%=0 · N/A=12',
      '',
      '── FQ GATE — hard institutional logic ───────────────────────────────────',
      'FQ 0-29:  signal capped at BEARISH — fundamental red flag overrides momentum',
      'FQ 30-49: signal capped at NEUTRAL — fundamental concern blocks upside',
      'FQ 50-69: no cap — full combined score applies',
      'FQ 70-89: +5 pts bonus to final score',
      'FQ 90+:   +10 pts bonus to final score',
      '',
      '── COMBINED SCORING ─────────────────────────────────────────────────────',
      'If ≥2 FQ dimensions available: score = (FQ × 0.40) + (MQ × 0.60)',
      '  MQ = V2 D1+D2+D3+D5 logic (momentum + relative strength + VIX regime)',
      '  Then apply FQ gate and bonus',
      'If FQ unavailable (ETF/foreign/thinly traded): score = V2 formula (no regression)',
      '',
      '── D2 TREND STRUCTURE UPGRADE ───────────────────────────────────────────',
      'Use REAL SMA50 + SMA200 from AV OVERVIEW (50DayMovingAverage, 200DayMovingAverage)',
      'SMA50 > SMA200 = golden cross confirmed → +8pts (was estimated from 52W)',
      'SMA50 < SMA200 = death cross confirmed → -15pts',
      'Price vs SMA200: above = +4pts structural uptrend · below = -8pts',
      '',
      '── TARGET PRICE V3 — USE ANALYST CONSENSUS ──────────────────────────────',
      'AnalystTargetPrice from AV OVERVIEW — already fetched, currently unused',
      'Primary source (50%): AnalystTargetPrice',
      'Secondary (30%): 200DayMovingAverage × 1.10 (trend projection)',
      'Tertiary (20%): ForwardPE × ForwardEPS if both available',
      'Analyst target comparison → extra signal:',
      '  Analyst target < current × 0.95 → -8pts (analysts see downside — catches RL)',
      '  Analyst target > current × 1.15 → +8pts (analysts see significant upside)',
      'Range: target ± (12% × beta) half-band — width scales with volatility',
      '',
      '── UI: TWO SUB-SCORES + ANALYST TARGET ──────────────────────────────────',
      'Show: Fundamental Quality X/100 + Momentum Quality X/100 → combined',
      'Show: FQ gate result — "Fundamental [Red Flag/Concern/Adequate/Strong]"',
      'Show: Analyst target vs current with direction indicator',
      'Show: which FQ dimensions had data vs unavailable (full transparency)',
      '',
      '── D3 VALUE ─────────────────────────────────────────────────────────────',
      'V3 adds signal QUALITY on top of V2 signal variance',
      'FQ gate ensures BEARISH is fundamentally earned, not just momentum-driven',
      'ORCL: high D/E ratio → FQ low → capped NEUTRAL → D3 short thesis valid',
      'RL: analyst target below price → downside signal → D3 contrarian input',
      'Proprietary combination: AV fundamentals + Finnhub debt metrics + SPY RS + VIX',
      'No vendor combines all these into a single score. This is the unique moat.',
      'SignalLog: now carries fundamental quality context → D3 L1 quality filter',
    ],
    prereqs: [
      'S27-ALGO V2 deployed ✅ (5c27af5) — signal variance baseline established',
      'Confirm AnalystTargetPrice in AV OVERVIEW mapAVtoCache() — check fundamentalsCache.js',
      'Confirm Finnhub metrics available in member path (currently only in Finnhub fallback)',
    ],
    doD: [
      'ORCL analysis scores ≤ NEUTRAL — high D/E ratio caught by FQ Dim C',
      'RL analysis shows analyst downside warning — AnalystTargetPrice < current price',
      'Scoring breakdown shows FQ (X/100) + MQ (X/100) as two distinct sub-scores',
      'Analyst target price displayed: "Wall Street consensus: $X.XX (±X%)"',
      'SMA50 + SMA200 from AV OVERVIEW used for D2 trend structure',
      'Finnhub metrics fetched in PARALLEL with AV in member path (not just fallback)',
      'All fundamentals fields passed into generateAnalysis (not just beta+avgVol)',
      'ETFs and thinly-traded fall back to V2 gracefully (no regression)',
      'FQ partial data handled cleanly — scored on available dimensions only',
      'CI=true npm run build clean',
      'smoke-test.sh: FQ + analyst target + SMA checks passing',
    ],
    smokeChecks: [
      'grep -qE "fqScore|fundamentalQuality|FQ score" backend/routes/stocks.js && echo "FQ score in algorithm"',
      'grep -qE "AnalystTargetPrice|analystTarget" backend/routes/stocks.js && echo "Analyst target used"',
      'grep -qE "debtEquity|debtToEquity" backend/routes/stocks.js && echo "Debt ratio in scoring"',
      'grep -qE "revenueGrowth|RevenueGrowth" backend/routes/stocks.js && echo "Revenue growth in scoring"',
      'grep -qE "fqScore|FundamentalQuality|fqGate" src/components/stock/HeroSignal.jsx && echo "FQ in HeroSignal"',
    ],
    files: [
      'backend/routes/stocks.js',
      'backend/utils/fundamentalsCache.js',
      'src/components/stock/HeroSignal.jsx',
      'src/data/sessions.js',
    ],
    vendorDeps: [
      { name: 'Alpha Vantage OVERVIEW', plan: 'Already fetched — AnalystTargetPrice + SMAs + fundamentals', status: 'USE EXISTING — zero new calls' },
      { name: 'Finnhub /stock/metric', plan: 'Already fetched in fallback — move to parallel member path', status: 'USE EXISTING — zero new cost' },
    ],
  },

  {
    id: 'S27H-UI',
    sessionNumber: 'S27H-UI',
    name: 'Chart UI V2 — Floating Indicator Pills + Collapsible Sidebar + Sub-Panel Zones',
    status: 'done',
    date: 'April 2026',
    commit: 'ed939f3',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── CARRY-FORWARD FROM S27-ALGO-V3 (low priority, do in this session) ──',
      'D3 GAP: Performance section renders but view not logged — add ChartInteractionLog call when perf data loads',
      'D3 GAP: Calculator navigation from HeroPrice has no ticker context — pass { sourceTicker, signal, score } to log cross-signal conviction correlation',
      '',
      '── WHY THIS SESSION ─────────────────────────────────────────────────────',
      'Current chart UI is functional but cluttered — indicator toggles wrap on small screens',
      'TV logo removed (S27H-hotfix1) but our brand presence on chart is still zero',
      'Finviz email (April 2026) confirms: chart templates + indicator UI = competitive battleground',
      'Our principle: NO vendor identity anywhere. Our unique design only.',
      '',
      '── FLOATING INDICATOR PILL BAR ─────────────────────────────────────────',
      'Remove the top-strip indicator toggles (cluttered, wraps on mobile)',
      'Replace with floating glassmorphism pill bar anchored to bottom of chart',
      'Each active indicator = a coloured pill with icon + label (BB · MACD · VWAP etc)',
      'Click pill to disable. + button opens indicator picker.',
      'D3 value: pill bar interaction logs indicator_toggle events with session context',
      '',
      '── COLLAPSIBLE SIDEBAR DRAWER ──────────────────────────────────────────',
      'Current: 210px fixed sidebar always visible in fullscreen — wastes chart real estate',
      'New: sidebar collapsed by default (◀ handle only)',
      'Click handle → slides open 220px drawer with blur backdrop',
      'D3 value: sidebar_open event logged → active strategy session signal',
      'D3 value: sidebar stays closed → passive viewer — different signal weight in L2',
      '',
      '── RSI / MACD / STOCH SUB-PANEL IMPROVEMENTS ───────────────────────────',
      'RSI: coloured area fill — below 30 = soft green tint, above 70 = soft red tint',
      'RSI: 50-line dotted reference + "RSI(14)" label top-left corner',
      'MACD: "MACD(12,26,9)" label + zero-line label, histogram green/red confirmed',
      'Stochastic: %K/%D labels on panel + overbought/oversold zone background tints',
      '',
      '── ADVANCED BUTTON UPGRADE (StockPage Technicals tab) ──────────────────',
      'Current: small low-contrast "⛶ Advanced" button — easy to miss',
      'New: full-width banner below embedded chart:',
      '  "🔬 Open Advanced Chart — Bollinger · MACD · Templates · Drawings →"',
      'D3 value: banner click = member wants deeper analysis = high conviction D3 signal',
      '',
      '── CHART BRAND IDENTITY ─────────────────────────────────────────────────',
      'MarketPulze watermark: subtle "M" mark bottom-left, very low opacity',
      'All changes: inline styles only (Rule 7), no new npm packages (NEVER_DO)',
      '',
      '── NOTE: This is NOT Chart Engine V2 ───────────────────────────────────',
      'chart-engine-v2 = replace lightweight-charts with custom canvas (Phase C)',
      'S27H-UI = improve the UI around lightweight-charts (Phase B, incremental)',
    ],
    prereqs: ['S27-ALGO deployed ✅', 'S27H-hotfix1 deployed ✅ (TV logo removed)'],
    doD: [
      'Floating indicator pill bar replaces top-strip toggles (inline styles only)',
      'Sidebar collapsed by default — slides open on click',
      'sidebar_open event logged to ChartInteractionLog',
      'RSI area fill: green below 30, red above 70',
      'Advanced chart banner full-width below StockPage embedded chart',
      'Subtle MarketPulze watermark on chart — no TV logo or third-party branding visible',
      'CI=true npm run build clean',
      'smoke-test.sh additions passing',
    ],
    smokeChecks: [
      'grep -qE "sidebar_open|sidebarOpen" src/components/PriceChart.jsx && echo "sidebar_open event logged"',
      'grep -qE "pillBar|indicator.*pill|floating.*pill" src/components/PriceChart.jsx && echo "Floating pill bar present"',
    ],
    files: [
      'src/components/PriceChart.jsx',
      'src/pages/StockPage.jsx',
      'src/data/sessions.js',
    ],
    vendorDeps: [],
  },

  {
    id: 'S27-CHART-ENGINE',
    sessionNumber: 'a31cf53',
    name: 'Chart Engine V2 — Pure D3.js Migration (Apache 2.0 · Zero Restrictions · OCI-8 Native)',
    status: 'done',
    date: 'April 2026',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── WHY THIS SESSION — ARCHITECTURAL DECISION (April 2026) ──────────────',
      'Current: lightweight-charts v4.x — TradingView Proprietary License',
      'Free commercial use ONLY with "Charting by TradingView" watermark shown',
      'Removing watermark = license violation without paid TradingView license',
      'This is a foundational restriction that travels to every downstream feature:',
      '  S27I Fibonacci, S27-DRAWING-V2, S27K analyst overlays, OCI-8 D3 signal layer',
      'Decision: migrate to d3fc + D3.js — zero restrictions forever, OCI-8 native',
      '',
      '── WHY d3fc + D3.js NOT raw D3.js ──────────────────────────────────────',
      'd3fc (Scott Logic, Apache 2.0) = D3.js with financial chart primitives pre-built',
      'Provides: candlestick series, OHLC series, area/line series, time scale, axes',
      'Without d3fc: ~1100 lines of foundational rendering before features start',
      'With d3fc: ~300 lines of foundation + all D3 power + all chart types',
      'All our calculation code (calcSMA, calcEMA, calcBollinger etc) = pure JS, unchanged',
      'All D3 logging (logInteraction) = fetch calls, unchanged',
      'All MongoDB models (Drawing, IndicatorLayout, ChartInteractionLog) = unchanged',
      'All pill bar/sidebar UI components = unchanged',
      '',
      '── WHY NOT APACHE ECHARTS ──────────────────────────────────────────────',
      'ECharts is Apache 2.0 but requires ECharts custom series adapter for D3 signals',
      'D3.js signal layer at OCI-8 would need translation into ECharts coordinate system',
      'd3fc + D3.js: OCI-8 D3 signal layer IS the same rendering system — zero translation',
      'Single migration now vs two migrations (ECharts now, D3 later) = correct choice',
      '',
      '── D3 SIGNAL VALUE ─────────────────────────────────────────────────────',
      'chart_type_change event: member switches Candlestick→Heikin Ashi→Renko = trading style',
      '  Renko user = price action purist = D3 L2 strategy fingerprint',
      '  Mountain user = trend follower = different D3 weighting',
      '  Candlestick default = standard = no fingerprint bonus',
      'chart_type_preference stored in IndicatorLayout + logged to ChartInteractionLog',
      '',
      '── CHART TYPES TO IMPLEMENT ────────────────────────────────────────────',
      'Candlestick (default) — standard OHLC candles',
      'Heikin Ashi — smoothed candles, trend clarity for swing traders',
      'OHLC Bar — traditional bar chart, classic institutional look',
      'Mountain/Area — filled line chart, trend followers + guests (less intimidating)',
      'Line — simple close-price line, clean momentum view',
      'Renko — price action only, no time axis, pure momentum traders',
      '',
      '── WHAT SURVIVES THE MIGRATION (our code, unchanged) ───────────────────',
      'calcSMA, calcEMA, calcBollinger, calcVWAP, calcMACD, calcRSI, calcStochastic',
      'calcHeikinAshi (new, trivial — 4 lines)',
      'calcRenko (new, ~30 lines)',
      'logInteraction → /api/chart-signals/log — ALL D3 events preserved',
      'Drawing persistence — Drawing model, /api/drawings, DrawingLog',
      'IndicatorLayout persistence — model gets chartType field added',
      'Floating pill bar (ActivePill, AddPill, IndicatorPicker) — unchanged',
      'Collapsible sidebar — unchanged',
      'ChartPage.jsx — URL state logic unchanged',
      'MarketPulze branding — unchanged',
      '',
      '── WHAT CHANGES ────────────────────────────────────────────────────────',
      'PriceChart.jsx: createChart → d3fc + D3.js config (~500 lines change out of 1800)',
      'package.json: add d3, d3fc — remove lightweight-charts',
      'IndicatorLayout.js: add chartType field',
      'smoke-test.sh: replace lightweight-charts checks with d3fc checks',
      '',
      '── SESSION SCOPE ────────────────────────────────────────────────────────',
      'Deliverable 1: d3fc candlestick + volume + all existing SMA/BB/VWAP/EMA overlays',
      'Deliverable 2: RSI + MACD + Stoch sub-panels with synchronized zoom',
      'Deliverable 3: Chart type switcher (6 types) with IndicatorLayout persistence',
      'Deliverable 4: All drawing tools preserved (trendline, horizontal)',
      'Deliverable 5: All D3 logging preserved + chart_type_change event added',
      'Deliverable 6: TV watermark gone — zero vendor attribution anywhere',
      'Deliverable 7: dataZoom slider (timeline scrubber — TV standard)',
      '',
      '── PREREQUISITE ─────────────────────────────────────────────────────────',
      'Upload: PriceChart.jsx, ChartPage.jsx, IndicatorLayout.js, package.json',
      'Confirm: lightweight-charts actual installed version (npm list lightweight-charts)',
    ],
    keyFiles: [
      'src/components/PriceChart.jsx',
      'src/pages/ChartPage.jsx',
      'backend/models/IndicatorLayout.js',
      'package.json',
      'scripts/smoke-test.sh',
    ],
    d3Signal: 'chart_type_change → L2 strategy fingerprint. Renko/HeikinAshi = sophisticated trader segment.',
    legalNote: 'lightweight-charts v4 = TradingView Proprietary. d3fc = Apache 2.0 (Scott Logic). D3.js = BSD 3-Clause. Both zero commercial restrictions, zero attribution.',
  },

  {
    id: 'S27I',
    sessionNumber: 'S27I',
    name: 'Fibonacci Retracement + Drawing System V2 + Scanner-Chart Signal Chain',
    status: "done", date: "2026-04", commit: "b769572",
    phase: 'Phase 2 — Signal Collection',
    items: [
      'Fibonacci retracement tool — two-click drag → 7 standard ratio levels (0, 23.6, 38.2, 50, 61.8, 78.6, 100%)',
      'Fibonacci extension tool — levels at 100, 127.2, 161.8, 200% above/below swing high/low',
      'createPriceLine() for each fib level — colour-coded (61.8% gold, 50% white, 38.2% teal), labelled, auto-aligned',
      'DrawingLog schema extension: fibLevel field (0-100 scale), fibType (retracement/extension)',
      'D3 value: fib levels drawn by multiple members clustering at same price = crowd-validated institutional S/R',
      'No vendor sells per-member fibonacci levels. Highest-value D3 signal in the chart suite.',
      'Drawing V2: save/load named drawing sets per ticker — "My NVDA Setup", "Support Zones"',
      'Drawing V2: copy drawing to another ticker — fast setup for similar patterns',
      'scanContext scanner-chart signal chain — full chain from scan type to chart interaction logged',
      'scan_to_chart_drawing event in ChartInteractionLog — member arrives from screener scan AND draws = highest-confidence D3 signal',
      'IndicatorLayoutLog — fire-and-forget analytics every indicator toggle for strategy fingerprint',
      'Guest: fibonacci visible + usable, isGuest: true in DrawingLog, no persistence',
      'Member: fibonacci drawings persist via Drawing model (drawingType: fibonacci)',
    ],
    prereqs: [
      'S27H deployed — full chart page + Bollinger + MACD + VWAP + templates live',
    ],
    doD: [
      'Fibonacci retracement draws 7 createPriceLine() levels from two clicks',
      'Fibonacci levels use standard colours — 61.8% gold, 38.2% teal, 50% subtle white',
      'DrawingLog records fibLevel and fibType on fibonacci drawings',
      'scan_to_chart_drawing event fires in ChartInteractionLog when scan→chart→draw chain completes',
      'Named drawing sets save + load for members (UI in full chart sidebar)',
      'No regression: trendlines + horizontals + SMA + RSI + Bollinger + MACD all render',
      'CI=true npm run build clean',
      'smoke-test.sh — fibonacci smoke checks added and passing',
    ],
    smokeChecks: [
      'grep -qE "fibonacci|Fibonacci|fib" src/components/PriceChart.jsx && echo "Fibonacci in PriceChart"',
      'grep -q "fibLevel" backend/models/DrawingLog.js && echo "fibLevel in DrawingLog schema"',
      'grep -qE "scan_to_chart|scanContext" src/components/PriceChart.jsx && echo "scanContext in PriceChart"',
    ],
    files: [
      'src/components/PriceChart.jsx',
      'backend/models/DrawingLog.js',
      'src/data/sessions.js',
    ],
    vendorDeps: [],
  },

  {
    id: 'S27J',
    sessionNumber: 'S27J',
    name: 'Screener Phase 2 — Member Saved Filters + Alert Builder + Technical Columns',
    status: 'done',
    date: 'April 2026',
    commit: '5486c1f',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── WHY THIS MATTERS ─────────────────────────────────────────────────────',
      'Current screener: guests and members see same filters. No member differentiation.',
      'Members need: saved scans (daily retention loop) + alerts (brings them back)',
      'Saved filters = persistent strategy fingerprint → D3 strategy assignment signal',
      '',
      '── MEMBER SAVED FILTERS ────────────────────────────────────────────────',
      'Members can name and save any filter combination: "My Oversold Tech Plays" etc',
      'SavedScan MongoDB model: memberId, name, filters JSON, createdAt, lastUsed',
      'One-click reload of any saved scan from a personal scan library',
      'Guest: "Save this scan →" gates to "Request Invite" CTA',
      '',
      '── SCAN ALERT BUILDER ──────────────────────────────────────────────────',
      '"Alert me when NVDA enters Top BULLISH scan" → SMTP2GO email',
      'Alert types: signal change (NEUTRAL→BULLISH), score threshold breach, scan entry',
      'Members: up to 5 active alerts (configurable via Admin config: scan_alert_limit)',
      'ScanAlert MongoDB model: memberId, scanId, alertType, lastFired, isActive',
      'Cron: check alerts every 15min during market hours using existing screener cache',
      '',
      '── TECHNICAL COLUMNS ───────────────────────────────────────────────────',
      'Add optional columns to screener results table: RSI · 52W Position % · Volume Ratio',
      'Column picker: member selects which additional columns to display',
      'Renders from existing 15-min cached data — zero new API calls',
      '',
      '── D3 VALUE ─────────────────────────────────────────────────────────────',
      'Saved filter name = member strategy declaration (momentum/contrarian/value/sector)',
      'Alert triggered + member acts within 30min = confirmed live strategy conviction signal',
      'Column selection = which metrics member monitors = strategy sophistication fingerprint',
      'Rule 20: ✅ D3 quality · ✅ member retention → subscription conversion · ✅ proprietary data',
    ],
    prereqs: [
      'S27I deployed ✅ (scanner-chart signal chain live)',
      'S27-ALGO deployed ✅ (screener results must be trustworthy before members save them)',
    ],
    doD: [
      'Members can save named filter combinations to MongoDB',
      'Saved scans reload with one click from personal scan library',
      'Alert fires via SMTP2GO when scan condition met for a watched ticker',
      'Technical columns picker: RSI + 52W Position + Volume Ratio selectable',
      'Guest gate on save/alert shows "Request Invite" CTA',
      'CI=true npm run build clean',
      'smoke-test.sh additions passing',
    ],
    smokeChecks: [
      'test -f backend/models/SavedScan.js && echo "SavedScan model exists"',
      'test -f backend/models/ScanAlert.js && echo "ScanAlert model exists"',
      'grep -qE "savedScan|saved-scan|SavedScan" backend/routes/screener.js && echo "Saved scan in screener route"',
    ],
    files: [
      'src/pages/ScreenerPage.jsx',
      'backend/routes/screener.js',
      'backend/models/SavedScan.js',
      'backend/models/ScanAlert.js',
      'src/data/sessions.js',
    ],
    vendorDeps: [
      { name: 'SMTP2GO', plan: 'Free 1000/mo', endpoint: 'scan alert emails', status: 'Already active' },
    ],
  },

  {
    id: 'S27K',
    sessionNumber: 'S27K',
    name: 'Analyst Ratings on Chart + Price Alerts — D3 Level Conviction Signal',
    status: 'done', date: '2026-04', commit: '3a99785',
    phase: 'Phase 2 — Signal Collection',
    items: [
      '── ANALYST RATINGS ON CHART ─────────────────────────────────────────────',
      'Finviz email (April 2026): "Analyst ratings now built into stock charts" — our equivalent',
      'Overlay analyst upgrade/downgrade events as markers on the candlestick series',
      'lightweight-charts v4 addMarker() API — each event = coloured marker on the bar',
      'Upgrade = green ▲ marker · Downgrade = red ▼ marker · Initiation = blue ◆ marker',
      'Click/hover marker: tooltip shows firm, analyst, from→to rating, price target',
      'Data source: Finnhub /stock/recommendation + /stock/price-target (both free tier)',
      'D3 value: analyst downgrade + member ignores it + enables Breakout template = contrarian conviction',
      'D3 value: analyst_marker_view event — did member look at rating before setting alert?',
      'Full D3 chain: screener scan → chart view → analyst marker seen → alert set = 4-layer signal',
      '',
      '── PRICE ALERTS ─────────────────────────────────────────────────────────',
      'Click-to-set: member clicks price scale on chart → "Set Alert at $X.XX?" confirm',
      'PriceAlert MongoDB model: memberId, ticker, targetPrice, direction (above/below)',
      'Alert check cron: every 15min during market hours vs cached SEO price',
      'Fire: SMTP2GO email "NVDA hit your alert at $950.00 · [View Chart]"',
      'Members: up to 10 active price alerts (configurable: price_alert_limit in Admin config)',
      'D3 value: alert set = specific price level conviction → demand_amplifier at that level',
      'D3 value: alert clusters from multiple members at same price = crowd psychological level → D3 L3',
      'Guest: sees alert UI but gate shows "Members only → Request Invite"',
      '',
      '── COMBINED D3 SIGNAL CHAIN (highest value in chart suite) ─────────────',
      'Member: screener scan → chart → sees analyst downgrade → sets alert above → draws fib',
      '= Full chain: screener strategy + technical setup + analyst context + conviction + fib target',
      'No vendor sells this 5-layer proprietary chain. This is the moat.',
    ],
    prereqs: [
      'S27I deployed ✅ (fibonacci + drawing system V2 — fib levels needed for full chain)',
      'S27-ALGO deployed ✅ (analyst ratings displayed against trustworthy algorithm scores)',
    ],
    doD: [
      'Analyst upgrade/downgrade markers render on candlestick series at correct time bars',
      'Marker tooltip shows firm + analyst + from→to rating + price target on hover',
      'analyst_marker_view event fires in ChartInteractionLog on marker interaction',
      'Click price scale → set alert flow works end to end',
      'PriceAlert model in MongoDB with memberId + ticker + targetPrice + direction + status',
      'Alert fires via SMTP2GO when price crosses target (15min cron)',
      'Guest gate on alert UI shows Request Invite CTA',
      'CI=true npm run build clean',
      'smoke-test.sh additions passing',
    ],
    smokeChecks: [
      'test -f backend/models/PriceAlert.js && echo "PriceAlert model exists"',
      'grep -qE "addMarker|analyst_marker|analystMarker" src/components/PriceChart.jsx && echo "Analyst markers in PriceChart"',
      'grep -qE "price-alert|priceAlert|PriceAlert" backend/routes/chart-signals.js && echo "Price alert route exists"',
    ],
    files: [
      'src/components/PriceChart.jsx',
      'backend/models/PriceAlert.js',
      'backend/routes/chart-signals.js',
      'src/data/sessions.js',
    ],
    vendorDeps: [
      { name: 'Finnhub', plan: 'Free', endpoint: '/stock/recommendation + /stock/price-target', status: 'Already in stack — no additional cost' },
      { name: 'SMTP2GO', plan: 'Free 1000/mo', endpoint: 'price alert emails', status: 'Already active' },
    ],
  },

  {
    id: 'sdlc-9file-system',
    sessionNumber: 'S27E-SDLC',
    name: 'SDLC 9-File System — Panel CPI + SESSION_LOCK + TEAM + NEW_CHAT_STARTER',
    status: 'done',
    phase: 'Phase 2 — Signal Collection',
    items: [
      'Panel CPI (bootstrap ~5.7K chars) — never grows, permanent size limit',
      'Repo CPI (full, no limit) — all rules, history, decisions grow here',
      'SESSION_LOCK.md — active session lock, mandatory solo and team',
      'TEAM.md — roles, authority matrix, decision escalation path',
      'NEW_CHAT_STARTER.md — copy-paste to start any new chat session',
      'PRODUCT_GAPS.md — parked gaps for future discussion',
      'Content extraction gate — 8 items, one per file, changes every session',
      'SYNC REFRESH command — one word stops session, re-reads all files, resumes',
      'Rule 24: SESSION_LOCK mandatory for all sessions',
      'E16: SYNC REFRESH protocol — proactive and user-invoked',
    ],
    prereqs: ['S27E arch decisions committed (ccf5438)'],
    doD: [
      'SESSION_LOCK.md in repo root',
      'TEAM.md in repo root',
      'NEW_CHAT_STARTER.md in repo root',
      'PRODUCT_GAPS.md in repo root',
      'Panel CPI < 8000 chars, copied to claude.ai project panel',
      'Repo CPI updated with E16 + Rule 24',
      'sessions.js: Rule 24 + E16 documented',
    ],
    smokeChecks: [
      'test -f SESSION_LOCK.md',
      'test -f TEAM.md',
      'test -f NEW_CHAT_STARTER.md',
      'test -f PRODUCT_GAPS.md',
      'grep -q "SYNC REFRESH" SESSION_LOCK.md',
      'grep -q "Rule 24" src/data/sessions.js',
    ],
    files: ['SESSION_LOCK.md','TEAM.md','NEW_CHAT_STARTER.md','PRODUCT_GAPS.md',
            'CLAUDE_PROJECT_INSTRUCTIONS.md','src/data/sessions.js'],
    vendorDeps: [],
  },

]; // end ARCHIVE_SESSIONS
